import { render, staticRenderFns } from "./staffStatistics.vue?vue&type=template&id=275a5c18&scoped=true"
import script from "./staffStatistics.vue?vue&type=script&lang=js"
export * from "./staffStatistics.vue?vue&type=script&lang=js"
import style0 from "./staffStatistics.vue?vue&type=style&index=0&id=275a5c18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a5c18",
  null
  
)

export default component.exports